import { render, staticRenderFns } from "./AppFeedback.vue?vue&type=template&id=0d17ce1d&scoped=true&"
import script from "./AppFeedback.vue?vue&type=script&lang=js&"
export * from "./AppFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AppFeedback.vue?vue&type=style&index=0&id=0d17ce1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17ce1d",
  null
  
)

export default component.exports